import Seo from 'src/components/Seo';
import React, { useEffect, useState } from 'react';
import Styles from "./styles.module.css";
import Logos from "./../../image/search/logoa.png";
import { useNavigate } from 'react-router-dom';
import { collection, getDocs, getFirestore } from 'firebase/firestore';
import DefaultImage from './../../image/default/recruit.png';

const Top: React.FC = () => {
  
  const seoProps = {
    title: 'memorii works（メモリーワークス）｜美容学生向け求人・就活サイト | 株式会社memorii',
    description: '株式会社memoriiが提供する「memorii works」は、美容学生の就活と美容室の新卒採用を支援する求人サイト。サロン見学・応募・管理まで一括で対応。',
    canonical: 'https://memorii-works.com/',
  };

  const navigate = useNavigate();

  const [ recruitList, setRecruitList ] = useState<any[]>([]);

  const db = getFirestore();

  useEffect(() => {
    const load = async () => {
      const snap = await getDocs(collection(db, "searchIndex"));
      const list = snap.docs.map((d) => ({
        id: d.id,
        ...d.data(),
      }));
      setRecruitList(list);
    };
    load();
  }, []);
  
  return (
    <>
    <Seo {...seoProps}>
      <div className={Styles.header}>
        <div className={Styles.logo}>
          <img src={Logos} />
          <div>
            <p>美容学生のための就活アプリ</p>
            <h2>memorii</h2>
          </div>
        </div>
        
        <div className={Styles.links}>
        </div>
      </div>

      <div className={Styles.list}>
        {recruitList && recruitList.length === 0 && (
          <h4 className={Styles.list_none}>指定した条件で美容室を検索しましたが、該当する美容室がございませんでした。</h4>
        )}

      {recruitList && recruitList.map((data) => {

        const status = data.recruitStatus;
        const recruitImage = data.image;
        const jobPostingsImage = data.storeImage;

        // 求人ページ公開中でも image が空のことがあるため、その場合は1店舗目の写真(storeImage)を使う
        const imageUrl = status && recruitImage
          ? `https://firebasestorage.googleapis.com/v0/b/trankllc-com.appspot.com/o/styles%2Fresize_images%2F${recruitImage}_1080x1080?alt=media&token=`
          : `https://firebasestorage.googleapis.com/v0/b/trankllc-com.appspot.com/o/jobPostingsStore%2Fresize_images%2F${jobPostingsImage}_1080x1080?alt=media&token=`;

        return (
          <div
            key={data.id}
            className={Styles.list_box}
            onClick={() => navigate(`/recruit/id=${data.id}`)}
          >
            <img
              src={imageUrl}
              onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = DefaultImage;
              }}
            />

            <div>
              <img
                src={`https://firebasestorage.googleapis.com/v0/b/trankllc-com.appspot.com/o/companies_logo%2Fresize_images%2F${data.companyId}_200x200?alt=media&token=`}
                onError={(e) => {
                  e.currentTarget.onerror = null;
                  e.currentTarget.src = DefaultImage;
                }}
              />
              <h4>{data.name}</h4>
            </div>

            <h3>{data.title}</h3>
          </div>
        );
      })}
    </div>

      <div className={Styles.footer}>
        <div className={Styles.footer_bottom}>
          <div>
            <a href='https://memorii-works.com/policy-service' rel="nofollow noopener noreferrer">
              <p>プライバシーポリシー</p>
            </a>
            <a href='https://memorii-works.com/terms' rel="nofollow noopener noreferrer">
              <p>利用規約</p>
            </a>
          </div>
          <p>© Trankllc. All Rights Reserved.</p>
        </div>
      </div>
    </Seo>
    </>
  );
}

export default Top;
